@if (showAlert()) {
<cfp-alert
  [classes]="'mb-4'"
  [alertStyle]="'light'"
  [icon]="'info-circle'"
  [iconType]="'solid'"
  [iconStyle]="'primary'"
  [canDismiss]="true"
  (dismissed)="dismiss()"
>
  <p class="mb-1">{{ 'roadmap.measureRelationAlert' | translate }}</p>
  <cfp-link (clicked)="showMeasureRelationAlertModal()">{{ 'moreInformation' | translate }}</cfp-link>
</cfp-alert>
}
